import axiosInstance from './AxiosInstance';

export default axiosInstance;
